/**
 * 项目运行平台区分
 * */
export const platform = __UNI_PLATFORM__
export const isH5 = __UNI_PLATFORM__ === 'h5'
export const isApp = __UNI_PLATFORM__ === 'app'
export const isMp = __UNI_PLATFORM__.startsWith('mp-')
export const isMpWeb = isMp ? false : navigator.userAgent.toLowerCase().includes('micromessenger')
const PLATFORM = {
  platform,
  isH5,
  isApp,
  isMp,
  isMpWeb,
}
export default PLATFORM
